import React from 'react';
import PropTypes from "prop-types";
import { Fragment } from "react";
import { useSelector } from "react-redux";
import HeaderOne from "../wrappers/header/HeaderOne";
import HeaderOneMain from "../wrappers/header/HeaderOneMain";
import FooterOne from "../wrappers/footer/FooterOne";
import ScrollToTop from "../components/scroll-to-top";
import { useLocation } from "react-router-dom";

const LayoutOne = (props) => {
  const {
    children,
    headerContainerClass,
    headerTop,
    headerPaddingClass,
    headerPositionClass,
    containerStyle,
    ...otherProps
  } = props;
  
  // Redux에서 withcookieData 가져오기
  const withcookieData = useSelector(state => state.withcookie?.withcookieData);
  
  // 테마 및 메타데이터 추출
  const theme = withcookieData?.skin?.theme || {};
  const skin = withcookieData?.skin || {};
  
  // 색상 데이터 추출
  const colorSet = theme?.colorset || {};
  const primaryColor = colorSet?.primary || "";
  const secondaryColor = colorSet?.secondary || "";
  const tertiaryColor = colorSet?.tertiary || "";
  
  // 메타데이터 추출
  const metaTitle = skin?.headTitle || "";
  const metaDescription = skin?.headDescription || "";
  const metaKeywords = skin?.headKeywords || "";
  const metaOgImage = skin?.headOgImage || "";
  
  // 푸터 정보 추출
  const companyName = skin?.extra?.company_name || "";
  const address = skin?.address || "";
  const phone = skin?.phone || "";
  const email = skin?.email || "";
  
  // SNS 배너 정보
  const snsBanner = skin?.extra?.sns_banner || [];
  
  const location = useLocation();
  const isRoot = location.pathname === "/" || location.pathname === "";
  
  // 동적 스타일 생성 - 추출한 색상으로 CSS 변수 설정
  React.useEffect(() => {
    const root = document.documentElement;
    root.style.setProperty('--primary-color', primaryColor);
    root.style.setProperty('--secondary-color', secondaryColor);
    root.style.setProperty('--tertiary-color', tertiaryColor);
  }, [primaryColor, secondaryColor, tertiaryColor]);
  
  // HTML 메타데이터 설정
  React.useEffect(() => {
    // 페이지 제목 설정
    document.title = metaTitle;
    
    // 메타 태그 추가/수정 함수
    const updateMetaTag = (name, content) => {
      let metaTag = document.querySelector(`meta[name="${name}"]`);
      if (!metaTag) {
        metaTag = document.createElement('meta');
        metaTag.name = name;
        document.head.appendChild(metaTag);
      }
      metaTag.content = content;
    };
    
    // OG 메타 태그 추가/수정 함수
    const updateOgMetaTag = (property, content) => {
      let metaTag = document.querySelector(`meta[property="${property}"]`);
      if (!metaTag && content) {
        metaTag = document.createElement('meta');
        metaTag.setAttribute('property', property);
        document.head.appendChild(metaTag);
      }
      if (metaTag && content) {
        metaTag.content = content;
      }
    };
    
    // 메타데이터 설정
    updateMetaTag('description', metaDescription);
    updateMetaTag('keywords', metaKeywords);
    updateOgMetaTag('og:image', metaOgImage);
    updateOgMetaTag('og:title', metaTitle);
    updateOgMetaTag('og:description', metaDescription);
    
  }, [metaTitle, metaDescription, metaKeywords, metaOgImage]);
  
  return (
    <Fragment>
      <div style={containerStyle || {}}>
        {isRoot ? (
          <HeaderOneMain
            layout="container"
            top={headerTop}
            headerPaddingClass={headerPaddingClass}
            headerPositionClass={headerPositionClass}
            withcookieData={withcookieData}
            {...otherProps}
          />
        ) : (
          <HeaderOne
            layout="container"
            top={headerTop}
            headerPaddingClass={headerPaddingClass}
            headerPositionClass={headerPositionClass}
            withcookieData={withcookieData}
            {...otherProps}
          />
        )}
        {children}
        <FooterOne
          backgroundColorClass="bg-gray"
          // 여기 조정하면 됨
          spaceTopClass="pt-100"
          spaceBottomClass="pb-70"
          companyName={companyName}
          address={address}
          phone={phone}
          email={email}
          snsBanner={snsBanner}
          withcookieData={withcookieData}
        />
        <ScrollToTop/>
      </div>
    </Fragment>
  );
};

LayoutOne.propTypes = {
  children: PropTypes.node,
  headerContainerClass: PropTypes.string,
  headerPaddingClass: PropTypes.string,
  headerPositionClass: PropTypes.string,
  headerTop: PropTypes.string,
  containerStyle: PropTypes.object
};

export default LayoutOne;
